/* biome-ignore-all lint/suspicious/noExplicitAny: filter form */
import type React from "react"
import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"

export interface ReadingContentFilterValues {
  search?: string
  type?: string
  difficulty?: string
  status?: string
}

interface ReadingContentFilterFormProps {
  onSearch: (values: ReadingContentFilterValues) => void
  loading?: boolean
  initialValues?: ReadingContentFilterValues
}

export const SET_TYPE_OPTIONS = [
  { label: "Tất cả loại bộ", value: "" },
  { label: "Bộ từ hệ thống", value: "system" },
  { label: "Bộ từ người dùng", value: "user" },
]

export const DIFFICULTY_OPTIONS = [
  { label: "Tất cả độ khó", value: "" },
  { label: "Dễ (Easy)", value: "easy" },
  { label: "Trung bình (Medium)", value: "medium" },
  { label: "Khó (Hard)", value: "hard" },
]

export const STATUS_OPTIONS = [
  { label: "Tất cả trạng thái", value: "" },
  { label: "Sẵn sàng (Ready)", value: "ready" },
  { label: "Bản nháp (Draft)", value: "draft" },
  { label: "Lưu trữ (Archived)", value: "archived" },
]

export const ReadingContentFilterForm: React.FC<ReadingContentFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: any) => {
    onSearch({
      search: values.search?.trim() || undefined,
      type: values.type || undefined,
      difficulty: values.difficulty || undefined,
      status: values.status || undefined,
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: undefined,
      type: undefined,
      difficulty: undefined,
      status: undefined,
    })
  }

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          search: initialValues?.search || "",
          type: initialValues?.type || "",
          difficulty: initialValues?.difficulty || "",
          status: initialValues?.status || "",
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Tìm kiếm (Tên bộ, Tiêu đề bài đọc hoặc #ID)" name="search">
              <Input placeholder="Nhập tên bộ, tiêu đề bài hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5}>
            <Form.Item label="Loại bộ từ" name="type">
              <Select options={SET_TYPE_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5}>
            <Form.Item label="Độ khó bài đọc" name="difficulty">
              <Select options={DIFFICULTY_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Trạng thái bài đọc" name="status">
              <Select options={STATUS_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default ReadingContentFilterForm
